import React, { useState } from "react";
import { Form, Input, Row, Col } from "antd";
import PinCodeValidator from "../PincodeValidator";
import { ReactComponent as Reason } from "../../assests/images/SVG/check.svg";
import API from "../../api";
import urls from "../../api/urls";
const { VERIFY_GST } = urls;

const ClientOrgEdit = ({ getData }) => {
  const [checkStatus, setCheckStatus] = useState(false);
  const checkGST = async (event) => {
    const gstNumber = event.target.value.toUpperCase();

    if (gstNumber.length <= 14) {
      setCheckStatus(false);
      return;
    }

    try {
      const response = await API.Api(VERIFY_GST + gstNumber).get();
      const data = response?.response?.data?.result?.gstnDetailed || {};

      if (response.status && data?.gstinStatus?.toUpperCase() === "ACTIVE") {
        setCheckStatus(true);
      } else {
        setCheckStatus(false);
      }
    } catch (error) {
      console.error("Error verifying GST:", error);
      setCheckStatus(false);
    }
  };
  return (
    <Row gutter={16} className="global-form-row">
      <Col span={12}>
        <Form.Item
          name="clientName"
          label="Client Name"
          rules={[
            { required: true, message: "Please enter client name" },
            { min: 3, message: "Name must be at least 3 characters" },
          ]}
        >
          <Input placeholder="Enter client name" disabled={true} />
        </Form.Item>
      </Col>

      <Col span={12}>
        <Form.Item
          name="gstNo"
          label="GSTIN"
          rules={[
            {
              pattern:
                /^([0-9]{2}[a-zA-Z]{4}([a-zA-Z]{1}|[0-9]{1})[0-9]{4}[a-zA-Z]{1}([a-zA-Z]|[0-9]){3}){0,15}$/g,
              message: "Invalid GSTIN",
            },
          ]}
          className="accpickupPincodeParent"
        >
          <Input
            className="accpickupPincode"
            placeholder="Enter GSTIN"
            //disabled={getData?.status?.toLowerCase() === "approved" || disable}
            suffix={checkStatus ? <Reason /> : ""}
            maxLength={15}
            onChange={checkGST}
            // disabled={getData ? true : false}
            onKeyPress={(e) => {
              if (/[^A-Za-z0-9]/.test(e.key)) {
                e.preventDefault();
              }
            }}
            //style={{ textTransform: "uppercase" }}
            onInput={(e) => (e.target.value = e.target.value.toUpperCase())}
          />
        </Form.Item>
      </Col>

      <Col span={12}>
        <Form.Item
          name="panNumber"
          label="PAN Number"
          rules={[
            //{ required: true, message: "Please enter PAN number" },
            {
              pattern: /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/,
              message: "Please enter valid PAN number",
            },
          ]}
        >
          <Input placeholder="Enter PAN number" disabled={true} />
        </Form.Item>
      </Col>

      <Col span={12}>
        <Form.Item
          label="Aadhar Number"
          name="aadharNo"
          rules={[
            {
              pattern: /^[2-9]{1}[0-9]{11}$/,
              message: "Aadhaar number must be 12 digits and start with 2-9",
            },
          ]}
        >
          <Input placeholder="Enter Aadhaar number" maxLength={12} />
        </Form.Item>
      </Col>

      <Col span={12}>
        <Form.Item
          label="TAN Number"
          name="tanNo"
          rules={[
            {
              pattern: /^[A-Za-z]{4}[0-9]{5}[A-Za-z]{1}$/,
              message:
                "TAN must be in format AAAA99999A (4 letters, 5 digits, 1 letter)",
            },
          ]}
        >
          <Input
            placeholder="Enter TAN Number"
            maxLength={10}
            // onChange={(e) => {
            //   e.target.value = e.target.value.toUpperCase();
            // }}

            style={{ textTransform: "uppercase" }}
          />
        </Form.Item>
      </Col>
      <Col xs={24} sm={24} md={12} lg={12} xl={12}>
        <Form.Item
          name="mobileNumber"
          label="Mobile Number"
          rules={[
            {
              pattern: /^([1-9]{1}[0-9]{9}){0,10}$/g,
              message: "Invalid mobile number",
            },
          ]}
        >
          <Input
            placeholder="Enter phone number"
            onKeyPress={(e) => {
              if (/[^0-9]/.test(e.key)) {
                e.preventDefault();
              }
              if (e.target.value.length >= 10) {
                e.preventDefault();
              }
            }}
            maxLength={10}
          />
        </Form.Item>
      </Col>
      <Col xs={24} sm={24} md={12} lg={12} xl={12}>
        <Form.Item
          name="emailId"
          label="Email-ID"
          rules={[
            {
              type: "email",
              message: "The input is not valid E-mail",
            },
          ]}
        >
          <Input
            placeholder="Enter Email"
            onInput={(e) => (e.target.value = e.target.value.toLowerCase())}
          />
        </Form.Item>
      </Col>

      <Col span={24}>
        <Form.Item name="street" label="Address">
          <Input.TextArea rows={4} placeholder="Enter complete address" />
        </Form.Item>
      </Col>
      <Col span={12}>
        <Form.Item name="area" label="Area">
          <Input placeholder="Enter area" />
        </Form.Item>
      </Col>
      <Col span={12}>
        <PinCodeValidator
          formName={"pincode"}
          value={
            getData?.addresses?.find((e) => e?.type === "COLLECTION")?.pincode
          }
        />
      </Col>
    </Row>
  );
};

export default ClientOrgEdit;
